import {useRouteError} from 'react-router-dom';

type ErrorPageProps = {
  status?: number;
  error?: Error;
};

export function ErrorPage(props: ErrorPageProps) {
  const routeError = useRouteError();
  const error =
    props.error ??
    (routeError instanceof Error
      ? routeError
      : new Error(routeError ? String(routeError) : 'An unknown error occurred'));

  const status = props.status ?? ('status' in (routeError as Record<string, unknown> ?? {}) ? (routeError as any).status : undefined);

  // Log full error for debugging
  try {
    // eslint-disable-next-line no-console
    console.error('SPA Error:', error);
  } catch {}

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-950 px-6 text-center text-slate-100">
      <h1 className="text-3xl font-semibold tracking-tight">Something went wrong</h1>
      {status ? <p className="mt-2 text-sm text-slate-400">Status: {status}</p> : null}
      <p className="mt-4 max-w-md whitespace-pre-line text-sm text-slate-400">{error.message}</p>
      {error && (error as any).stack ? (
        <pre className="mt-4 max-w-3xl overflow-auto rounded bg-slate-900 p-3 text-left text-xs text-slate-300">
          {(error as any).stack}
        </pre>
      ) : null}
    </div>
  );
}
